
import React, { useState, useEffect } from "react";
import moment from 'moment';
import DataTable from '../../components/SATI/DataTable';
import { getAllCompanyUsers} from '../../helpers/satiBack';
import {getTableID} from '../../helpers/levelsHelper';



import "chartist/dist/scss/chartist.scss";

let dateRange = [moment().subtract(1, 'week'), moment()];


const HealthTableUsers = ({ user }) => {
  
  const [userData, setUserData] = useState([]);

  useEffect(() => {
    const start = dateRange[0];
    const end = dateRange[1];
    let usersPromise;
    usersPromise = new Promise((res, rej) => {
      getAllCompanyUsers(start, end)
        .then(data => {
          console.log('CompanyUsersData: ',data)
          setUserData(data);
          res();
        })
        .catch(err => {
          console.error(err);
          rej();
        })
    });
  }, []);

  const userTableData = {
    columns: [
      {
        label: 'ID',
        field: 'UsuarioID',
        // sort: 'asc',
        width: 50
      },
      {
        label: 'Nombre',
        field: 'Nombre',
        sort: 'asc',
        width: 200
      },
      {
        label: 'Ver perfil',
        field: 'Perfil',
        //sort: 'asc',
        width: 150
      }
    ],
    rows: userData.map(d => ({
      UsuarioID : d.usuarioId,
      Nombre : d.nombre,
      UltimaMedicion: d.StepsAVG,
      Perfil: getTableID(d.usuarioId, d.nombre)
    }))
  }

  return (
    <React.Fragment>
      <div className="container-fluid">
        <DataTable 
          title="Usuarios" 
          tableData={userTableData}
          id="usersTable"
          popoverTitle='users test'
          popoverBody='users test body'
        />
      </div>
    </React.Fragment>
  );
}

export default HealthTableUsers;
